import React from 'react'
import PropTypes from 'prop-types'
import {components} from 'react-select'
import {Scrollbar} from 'react-scrollbars-custom'

function MenuList(props) {
  if (props === undefined) {
    return null
  }
  return (
    <div>
      <Scrollbar className="menulist" style={{height: '300px'}}>
        <components.MenuList {...props}>{props.children}</components.MenuList>
      </Scrollbar>
    </div>
  )
}

MenuList.propTypes = {
  children: PropTypes.any,
}

export default MenuList
